export default "__VITE_ASSET__Cv9_V2iI__"